import { useRef } from 'react'
import { toast } from 'react-toastify'

interface IProps {
  formElements: any
  setFormElements: any
  selectedElement: any
  selectedField: any
  setTogglerFieldIndex: any
  setSubFormFieldIndexes: any
  allFormElements: any
  currentPageIndex: number
}

const SubFormSetup: React.FC<IProps> = ({
  formElements,
  setFormElements,
  selectedElement,
  selectedField,
  setTogglerFieldIndex,
  setSubFormFieldIndexes,
  allFormElements,
  currentPageIndex
}) => {
  let subformfieldscounter = useRef(1)

  // Helper function to update current page in the full structure
  const updateCurrentPage = (updatedPageElements: any) => {
    const newFormElements = [...allFormElements]
    newFormElements[currentPageIndex] = updatedPageElements
    setFormElements(newFormElements)
  }

  const FormFieldHandler = (component: any, index: number) => {
    let thefieldindex = formElements.length
      ? Math.max(...formElements.map((field: any) => field.fieldId))
      : 0
    let conditionalInclusionDependency = {
      conditionActive: true,
      basedOnElementOfIndex: 2000,
      comparisionOperation: '=',
      forValue: 'true'
    }

    let indexedFormInput = {
      ...component,
      copiedFromFieldAtFieldId: component.fieldId,
      includeOnCondition: conditionalInclusionDependency,
      fieldId: thefieldindex + subformfieldscounter.current++
    }

    setSubFormFieldIndexes((prev: any) => [...prev, component.fieldId])

    // Check if the component type is 'banner' or 'captcha'
    if (component.type === 'banner' || component.type === 'captcha') {
      // Find if there's an existing banner or captcha in formElements
      const existingIndex = formElements.findIndex(
        (element: any) => element.type === component.type
      )

      // If an existing element is found, override it; otherwise, add the new element
      if (existingIndex !== -1) {
        toast.warning(`${component.type} is already present.`)
      } else {
        const updatedPageElements = [...formElements, indexedFormInput]
        updateCurrentPage(updatedPageElements)
        toast.success(`Successfully added ${component.type} element`)
      }
    } else {
      // For other types, add the component to the subform fields
      const updatedPageElements = [...formElements]
      const selectedFieldObject = updatedPageElements[selectedField]

      if (!Object.isExtensible(selectedFieldObject)) {
        updatedPageElements[selectedField] = {
          ...selectedFieldObject
        }
      }

      updatedPageElements[selectedField].subformFields = [
        ...updatedPageElements[selectedField].subformFields,
        indexedFormInput
      ]

      updateCurrentPage(updatedPageElements)
      toast.success(`Successfully added ${component.type} element`)
    }
  }

  const handleDelete = (component: any, index: number) => {
    setSubFormFieldIndexes((prev: any) => {
      let updatedsffi = [...prev]
      updatedsffi = updatedsffi.filter((fieldId) => fieldId !== component.fieldId)
      return updatedsffi
    })

    const updatedPageElements = [...formElements]
    const selectedFieldObject = updatedPageElements[selectedField]

    if (!Object.isExtensible(selectedFieldObject)) {
      updatedPageElements[selectedField] = {
        ...selectedFieldObject
      }
    }

    updatedPageElements[selectedField].subformFields = updatedPageElements[
      selectedField
    ].subformFields.filter((sff: any) => sff.copiedFromFieldAtFieldId !== index)

    updateCurrentPage(updatedPageElements)
    toast.warning(
      `selected field with fieldId ${component.copiedFromFieldAtFieldId} has been removed from the subform`
    )
  }

  return (
    <div>
      <label className='form-label'>Subform Fields:</label>
      <div>
        <table>
          <tbody>
            {formElements.map((element: any, index: any) => {
              return (
                <tr
                  key={element.fieldId ?? `subform-field-${index}`}
                  className={
                    element.label !== selectedElement.label && element.type !== 'button'
                      ? ``
                      : `d-none`
                  }
                >
                  <td className='text-center'>
                    <input
                      type='checkbox'
                      className='btn-check mx-1'
                      name='togglerField'
                      autoComplete='off'
                      id={`${index}-subform-field`}
                      checked={selectedElement.subformFields?.find(
                        (se: any) => se.copiedFromFieldAtFieldId === formElements[index].fieldId
                      )}
                      onChange={(e) => {
                        console.log(`checked ${e.currentTarget.checked} on ${e.currentTarget.id}`)
                        e.currentTarget.checked
                          ? FormFieldHandler(formElements[index], index)
                          : handleDelete(formElements[index], index)
                      }}
                    />
                    <label className='btn btn-secondary' htmlFor={`${index}-subform-field`}>
                      {element.label ? element.label : element.type}
                    </label>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default SubFormSetup
